export default "__VITE_ASSET__794c9840__"